import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef, Output } from '@angular/core';

//User-Defined Components
import { Permission } from './../../../model/permission';
import { PermissionService } from '../../../service/component_dependent/permission.service';

import { PermissionsListComponent } from './../../shared/permissions-list/permissions-list.component';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { StorageService } from '../../../service/managers/storage.service';
import { templateSourceUrl } from '@angular/compiler';
import { JsonManager } from '../../../service/managers/json-manager';
//Angular powered Bootstrap

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})

export class PermissionsComponent implements OnInit {

  permission: Permission = {
    id: null,
    name: null,
    display_name: null,
    description: null,
    created_at: null,
    updated_at: null,
  };
  permissions: Permission[];

  searchText: string;
  tableHeads: string[];

  maxNumberOfItemsPerPage: number = 5;
  currentPage: number = 1;
  totalDataSize: number;
  lastPage: number;

  protected loading: boolean;


  constructor(private servicePermission: PermissionService, private notifierService: NotifierService,
    private storageService: StorageService) {

    this.tableHeads = ['#', 'Name', 'Display Name', 'Description', 'Created At'];
  }

  ngOnInit() {
    // this.storageService.restrictViewOfUser(document);
    console.log('ON INIT Permissions page')
    this.getListOfPermissions(this.maxNumberOfItemsPerPage, this.currentPage, this.searchText);
  }

  public onSubmit() {
    this.servicePermission.storePermission(this.permission).subscribe(
      (data: any) => {
        this.notifierService.showSuccess(data.message);
        this.clearRegistrationForm();
      },
      (error: any) => {
        console.log(error);
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
      },
    );
  }

  public onSwitchPage(maxNumberOfItemsPerPage: number, pageNumber: number, keyword: string) {
    this.getListOfPermissions(maxNumberOfItemsPerPage, pageNumber, keyword);
  }

  public searchItems(maxNumberOfItemsPerPage: number, keyword: string) {
    console.log("Searching for specific keyword..");
    this.getListOfPermissions(maxNumberOfItemsPerPage, 1, keyword);
  }

  //Class Functions
  private getListOfPermissions(maxNumberOfItems: number, pageNumber: number, keyword: string) {
    this.loading = true;

    if (keyword == undefined) {
      this.servicePermission.getPermissions(maxNumberOfItems, pageNumber).subscribe(
        (res: any) => {
          this.loading = false;
          let obj = res.data;
          this.reassignVariables(obj.current_page, obj.data, obj.total, obj.last_page);
        }
      );
    } else {
      this.servicePermission.getPermissionsWithKeyword(maxNumberOfItems, pageNumber, keyword).subscribe(
        (res: any) => {
          this.loading = false;
          let obj = res.data;
          this.reassignVariables(obj.current_page, obj.data, obj.total, obj.last_page);
        }
      );
    }

  }

  private reassignVariables(currentPage, data, size, lastPage): void {
    this.currentPage = currentPage;
    this.permissions = data;
    this.totalDataSize = size;
    this.lastPage = lastPage;
  }

  private clearRegistrationForm() {
    this.permission.id = null;
    this.permission.name = null;
    this.permission.display_name = null;
    this.permission.description = null;
  }

}
